import React from 'react';

function PublicDashboardEmptyAlertMessage() {
  return (
    <p style={{ marginBottom: '10px' }}>
      <a href="/s/alerts" className="btn btn-primary">
        Manage Alerts
      </a>
    </p>
  );
}

export default PublicDashboardEmptyAlertMessage;
